import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Field } from 'redux-form'
import { H3 } from 'components/common/Text/Text'
import model from '../../../viewModel'
import { APPOINTMENT_CHECKBOX_INPUT_COLOR_GREEN, POPULAR_SERVICES_ID } from '../../constants'
import ServicesBlock from '../../../ServicesBlock'

const PopularServices = ({ popularServiceItems }) =>
  <Wrapper id={ POPULAR_SERVICES_ID }>
    <PopularServicesHeading>
      Make a selection from our popular services below.
    </PopularServicesHeading>
    <Field
      { ...model.servicesSelector }
      component={ ServicesBlock }
      defaultData={ popularServiceItems }
      title="Popular"
      popularServices
      props={{ inputColor: APPOINTMENT_CHECKBOX_INPUT_COLOR_GREEN }} />
  </Wrapper>

PopularServices.propTypes = {
  popularServiceItems: PropTypes.arrayOf(PropTypes.shape())
}

export default PopularServices

const PopularServicesHeading = styled(H3)`
  margin-bottom: 20px;
`

const Wrapper = styled.div`
  margin-bottom: 20px;
`
